import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top when route changes
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant', // Use 'smooth' for smooth scrolling, 'instant' for immediate
    });
  }, [pathname]);

  return null;
};

export default ScrollToTop;